export default function Machines_D_4 (number = 1) {
  return {
    name: '位面熔炉',
    icon: '/static/img/machines/d4.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_D/Machines_D_4.js